module.exports = "<div [ngClass]=\"{'page-loader':!loaderId,'field-loader':loaderId&&!isContainer,'section-loader':isContainer}\" *ngIf=\"(loaderId&&isVisible)||!loaderId\">\n    <img *ngIf=\"!loaderId||isContainer\" src=\"assets/images/ee-logo.gif\" alt=\"logo\">\n\t<span><i *ngIf=\"loaderId&&!isContainer\" class=\"fa fa-circle-o-notch fa-spin fa-fw\"></i> {{message?message:'Loading...'}}</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/loader/loader.component.html
// module id = ./src/app/common/loader/loader.component.html
// module chunks = main